<template>
  <div class="home-info">
    <div
      v-for="(item,index) in homeData"
      :key="index"
      class="home-info-item">
      <div class="label">{{ item.label }}：</div>
      <div v-if="selectMonitorInfo" class="value">{{ useValue(item.key) }}</div>
    </div>
    <span
      v-if="selectMonitorInfo"
      class="batteryDetail"
      @click="showDetail"
    >更多详情</span>
    <EquipmentDetails
      :visible.sync="visible"
      :selectMonitorInfo="selectMonitorInfo"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { homeData } from '@/assets/js/registerType.js';
import EquipmentDetails from './EquipmentDetails.vue';
export default {
  // functional: true,
  props: {
    selectMonitorInfo: {
      type: Object,
      default: () => {}
    },
  },
  components:{
    EquipmentDetails
  },
  computed:{
      ...mapState(['USER','NUMBER']),
  },
  data(){
    return {
      visible:false,
      homeData:homeData.filter(item => item.type !== 'object' && item.type !== 'array').slice(0,20)
    }
  },
  methods: {
    useValue(key){
      return this.selectMonitorInfo[key];
    },
    showDetail() {
      this.visible = true;
    }
  }
  // render(h, { props }) {
  //   const { mydata } = props;
  //   const options = mydata;

  //   const items = options.map((item, index) => (
  //     <el-col class="BatteryInfo__item" key={index} span={4}>
  //       <span class="BatteryInfo__label">{item.label}</span>
  //       <span
  //         title={item.value}
  //         class={`BatteryInfo__text BatteryInfo__text_${item.type}`}
  //       >
  //         {item.value}
  //       </span>
  //     </el-col>
  //   ));
  //   return (
  //     <el-row class="BatteryInfo">
  //       {items}
  //       <span class="batteryDetail">更多详情</span>
  //     </el-row>
  //   );
  // }
};
</script>

<style lang="scss" scoped>
.home-info {
  position: relative;
  @include scrollBar();
  height: 180px;
  overflow-y: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  &-item{
    width: 25%;
    display: flex;
    justify-content:flex-start;
    padding: 10px 0;
    .label{
      color: #909090;
    }
    .value{
      color: #333;
    }
  }
}
.batteryDetail {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  background: rgba(0, 211, 184, 1);
  color: aliceblue;
  cursor: pointer;
}
</style>
